const map = {
	"./100.jpg": 621,
	"./100.png": 7453,
	"./Be10x.png": 5188,
	"./CertiProf.png": 4250,
	"./Leeds.png": 6885,
	"./Udemy.png": 86,
	"./alagappa.png": 5643,
	"./aws.png": 9967,
	"./b.png": 1446,
	"./batch_script.png": 6856,
	"./buld.jpg": 4281,
	"./codeInLogo.png": 7873,
	"./codeuino.jpg": 8314,
	"./cognizant.png": 771,
	"./coursera_logo.png": 1170,
	"./cra.png": 1568,
	"./dal.png": 9071,
	"./deeplearning_ai_logo.png": 9575,
	"./gandhi.png": 9497,
	"./github.png": 647,
	"./googleAssistant.jpg": 1659,
	"./google_logo.png": 9389,
	"./guidewire.png": 7419,
	"./hcl.png": 7925,
	"./hrishi2.png": 963,
	"./informatica_powercenter.png": 5532,
	"./ino.png": 7192,
	"./intel_logo.jpg": 8504,
	"./oracle.png": 3492,
	"./plsql.png": 276,
	"./prasath_profile.jpg": 3969,
	"./procede.png": 3608,
	"./putty.png": 5986,
	"./quicko.jpg": 6458,
	"./sal.png": 5016,
	"./spatialcut.png": 2210,
	"./sql_server.png": 7724,
	"./sriramanujar.png": 1095,
	"./stanford_logo.png": 6691,
	"./unix_script.png": 3024,
	"./vjt.png": 5756,
	"./vscode.png": 2332,
	"./wrighter.jpg": 8296
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;